import { useSecureGraphqlQuery } from '@psyomics/ui-common';

import {
  GetServicesForUploadDocument,
  GetServicesForUploadQuery,
  GetServicesForUploadQueryVariables,
} from './generated/referral-upload-jobs';

const useServicesForUpload = () => {
  const [{ data, fetching: pending }] = useSecureGraphqlQuery<
    GetServicesForUploadQuery,
    GetServicesForUploadQueryVariables
  >({ query: GetServicesForUploadDocument });

  return { services: data?.getServicesForUpload ?? [], pending };
};

export { useServicesForUpload };
